export default function convertMarkdownToPlainText(markdown: string) {
    if (!markdown) {
        return '';
    }

    return (
        markdown
            // Remove headers
            .replace(/#+\s*(.*)/g, '$1')

            // Remove emphasis (bold, italic)
            .replace(/\*\*(.*?)\*\*/g, '$1')
            .replace(/\*(.*?)\*/g, '$1')
            .replace(/__(.*?)__/g, '$1')
            .replace(/_(.*?)_/g, '$1')

            // Remove blockquotes
            .replace(/^\s*>\s+/gm, '')

            // Remove inline code and code blocks
            .replace(/`{1,3}(.*?)`{1,3}/g, '$1')

            // Remove images, preserve alt text
            .replace(/!\[(.*?)\]\(.*?\)/g, '$1')

            // Remove links, preserve link text
            .replace(/\[(.*?)\]\(.*?\)/g, '$1')

            // Convert lists to plain text
            .replace(/^\s*[-*+]\s+/gm, '• ')
            .replace(/^\s*\d+\.\s+/gm, '• ')

            // Remove horizontal rules
            .replace(/^\s*[-*_]{3,}\s*$/gm, '')

            // Clean up extra whitespace
            .replace(/\n\s*\n/g, '\n\n')
            .replace(/  +/g, ' ')
            .trim()
    );
}
